import React from 'react';
import _ from 'lodash';
import Pagination from 'react-js-pagination';
import PropTypes from 'prop-types';
import './pagination.scss';

const CustomPagination = ({
  currentPage,
  totalPage,
  onPageChange,
  itemsCountPerPage,
}) => {

  return (
    <div className='paginationWrapper'>
      <Pagination
        itemClass='page-item'
        linkClass='page-link'
        hideFirstLastPages
        activePage={currentPage}
        totalItemsCount={totalPage}
        itemsCountPerPage={itemsCountPerPage}
        onChange={(value) => {
          _.isFunction(onPageChange) && onPageChange(value)
        }
        }
      />
    </div>
  )
}
CustomPagination.propTypes = {
  currentPage: PropTypes.number,
  totalPage: PropTypes.number,
  onPageChange: PropTypes.func,
  itemsCountPerPage: PropTypes.number,
};

export default CustomPagination;